<template lang="pug">

transition(
  appear
)
  .icon-menu
    svg(width="100%" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg")
      g(stroke="#fff" stroke-width="2")
        path(d="M0 1 h26")
        path(d="M0 13 h26")
        path(d="M0 25 h26")


</template>

<script>
export default {
  name: 'icon-menu',
  components: {},
  data() {
    return {}
  },
  props: {},
  computed: {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
  watch: {},
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.icon-menu
  line-height: 0
  width: 100%
  //overflow: hidden









</style>
